export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14303.2d3bd3f3.jpg";